
/** Iconos de Skills */

import {
    SiHtml5,
    SiJirasoftware,
    SiCss3,
    SiJavascript,
    SiTypescript,
    SiReact,
    SiNextdotjs,
    SiRedux,
    SiAngular,
    SiExpress,
    SiAdobephotoshop,
    SiSequelize,
    SiMongodb,
    SiPostgresql,
    SiGithub,
    SiFirebase,
    SiDocker,
    SiSqlite

} from "react-icons/si"

import { IoLogoNodejs } from "react-icons/io"
import { FaJava } from "react-icons/fa"



export const skillsLenguajes = [
    { logo: <SiJavascript />, name: 'JavaScript' },
    { logo: <SiHtml5 />, name: 'HTML' },
    { logo: <SiTypescript />, name: 'TypeScript'},
    { logo: <FaJava />, name: 'Java'},
    // { logo: <SiWordpress />, name: 'Wordpress' },
]


export const skillsLibrerias = [
    { logo: <SiReact />, name: 'React JS' },
    { logo: <IoLogoNodejs />, name: 'Node JS'},
]


export const skillsFrameworks = [
    { logo: <SiCss3 />, name: 'SASS' },
    { logo: <SiNextdotjs />, name: 'Next JS' },
    { logo: <SiRedux />, name: 'Redux JS' },
    { logo: <SiAngular />, name: 'Angular +V6' },
    { logo: <SiExpress />, name: 'Express JS' },
    { logo: <SiSequelize />, name: 'Sequelize' },
    { logo: <SiMongodb />, name: 'Mongoose' },
]

export const skillSDB = [
    { logo: <SiSqlite />, name: 'SQL' },
    { logo: <SiPostgresql />, name: 'Postgre SQL' },
    { logo: <SiMongodb />, name: 'Mongo DB'},
];

export const SkillApplications = [
    { logo: <SiGithub />, name: 'Git, GitHub'},
    { logo: <SiJirasoftware />, name: 'Jira' },
    { logo: <SiFirebase />, name: 'Firebase' },
    { logo: <SiDocker />, name: 'Docker' },
    { logo: <SiAdobephotoshop />, name: 'Adobe PhotoShop' },
];

